import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { StatusLegend } from '@pandiafi/components'

type LegendProps = { className?: string }

export const DayReservableAreasLegends: React.FC<LegendProps> = ({
  className,
}) => {
  const { t } = useTranslation('storage')

  return (
    <StatusLegend className={className} direction="row">
      <StatusLegend.Item
        status="default"
        srLabel={t('aria.availableIndicator')}
      >
        {t('legend.available')}
      </StatusLegend.Item>

      <StatusLegend.Item
        status="disabled"
        srLabel={t('aria.reservedIndicator')}
      >
        {t('legend.reservedOrInactive')}
      </StatusLegend.Item>

      <StatusLegend.Item status="active" srLabel={t('aria.mineIndicator')}>
        {t('legend.mine')}
      </StatusLegend.Item>

      <StatusLegend.Item
        status="upcoming"
        srLabel={t('aria.mineUpcomingIndicator')}
      >
        {t('legend.mineUpcoming')}
      </StatusLegend.Item>
    </StatusLegend>
  )
}
